import { render, staticRenderFns } from "./newPasswordForm.vue?vue&type=template&id=0b550e35"
import script from "./newPasswordForm.vue?vue&type=script&lang=js"
export * from "./newPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./newPasswordForm.vue?vue&type=style&index=0&id=0b550e35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports